import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../../../../../utils/propUtils';
var VeltCommentsSidebarV2FilterContainerSectionControlChevron = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-filter-container-v2-section-control-chevron-wireframe", __assign({}, transformedProps), children));
};
export default VeltCommentsSidebarV2FilterContainerSectionControlChevron;
